<script>
import { mapActions } from 'vuex'
import AppModalRedefinirSenha from '@/components(new)/security/RedefinirSenha.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  name: 'Login',
  components: {
    AppModalRedefinirSenha
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      login: '',
      senha: '',
      loading: false,
      loginError: false,
      senhaError: false,
      modalIsOpen: false
    }
  },
  created () {
    if (this.$route.query?.redefinicao === 'true') {
      this.modalIsOpen = true
    }
  },
  methods: {
    ...mapActions({
      loginPortalSeguranca: 'auth/loginPortalSeguranca'
    }),
    async logar () {
      if (await this.$refs.observer.validate()) {
        await this.loginPortalSeguranca({ login: this.login, senha: btoa(this.senha) })
        this.$router.push({ name: 'termos' })
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      }
    },
    openModalRedefinirSenha () {
      this.modalIsOpen = true
    },
    closeModalRedefinirSenha () {
      this.modalIsOpen = false
    },
    criarConta () {
      this.$router.push({
        name: 'cadastroUsuario',
        params: {
          tipo: 'externo'
        }
      })
    }
  },
  computed: {
    urlTermo () {
      return process.env.BASE_URL + '#/termo-de-uso'
    },
    urlAviso () {
      return process.env.BASE_URL + '#/aviso-de-privacidade'
    }
  }
}
</script>

<template>
  <div>
    <div class="main">
     <AppModalRedefinirSenha
        v-if="modalIsOpen"
        class="modalSenha"
        @closeModal="closeModalRedefinirSenha"
      />

      <el-card class="box-card">
        <validation-observer ref="observer" tag="form">
          <form @keyup.enter="logar()">
            <div id="containerImagens">
              <div>
                <img class="logo" src="@/assets/images/logo.png" />
              </div>
              <div id="LineSeparator"></div>
              <div>
                <img class="logo" src="@/assets/images/logoAbcPa.png" />
              </div>
            </div>
            <div class="item">
              <validation-provider rules="required|cpf_cnpj" v-slot="{ errors }" mode="lazy">
                <el-input
                  class="input"
                  :class="{ erro: errors.length }"
                  placeholder="CPF/CNPJ"
                  id="input_cpf"
                  v-model="login"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  masked="true"
                />
                <span class="help erro">{{ errors[0] }}</span>
              </validation-provider>
            </div>

            <div class="item">
              <validation-provider rules="required" v-slot="{ errors }" mode="lazy">
                <el-input
                  class="input"
                  :class="{ erro: errors.length }"
                  placeholder="Senha"
                  v-model="senha"
                  id="input_senha"
                  type="password"
                />
                <span class="help erro">{{ errors[0] }}</span>
              </validation-provider>
            </div>

            <div class="item">
              <el-button
                class="full-width"
                @click="logar()"
                :disabled="loading"
                type="success"
                style="width: 100%;"
              >
                <span v-if="!loading">Entrar</span>
                <i v-else class="el-icon-loading"></i>
              </el-button>
            </div>
          </form>
        </validation-observer>

        <div class="buttons">
          <el-button @click="openModalRedefinirSenha()" type="text">
            <span>Redefinir senha</span>
          </el-button>
          <el-button @click="criarConta()" type="text">
            <span>Criar conta</span>
          </el-button>
        </div>
      </el-card>
      <div class="links-container">
        <a :href="urlAviso" target="_blank">Aviso de Privacidade</a>
        <a :href="urlTermo" target="_blank">Termos de uso</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(unauthenticated)/seguranca/login-portal-acesso/login-portal-acesso.vue